var partnership = {
    list: function (page) {
        var params = $(".admin-form :input").serializeObj();
        params.page = page || 1;
        var getParams = location.pathname+"?"+($.param(params));
        if(window.history && window.history.replaceState){
            window.history.replaceState(null, null, getParams);
            $.get(getParams,params,function(resp){
                $("#partnership_list").html(resp)
            });
        }else{
            location.href=getParams;
        }
    },
    save: function (partnershipID) {
        var params = $(".admin-form :input").serializeObj(false);
        $.post('/partnership/partnerships/save/'+partnershipID,params,function(){
            location.href = '/partnership/partnerships';
        }).fail(function(resp) {
            utils.error(resp.responseJSON);
        });
    },
    delete: function (partnershipID) {
        popup(trans('Are you sure you want to remove this partnership?'), trans('Confirm: Remove partnership')).confirm(true, function(result) {
            if (result) {
                $.post('/partnership/partnerships/deletePartnership/'+partnershipID,{},function(){
                    partnership.list();
                })
            }
        });
    },
    addNew: function () {
        var countryID = $("#hcountryID").val();
        var partnershiplevelID = $("#hpartnershiplevelID").val();
        if(typeof countryID == 'undefined' || countryID == 0 || typeof partnershiplevelID == 'undefined' || partnershiplevelID == 0){
            popup('Please select country and partnership level', 'Warning').dialog();
        }else{
            $.post('/partnership/partnerships/addNew/'+countryID+'/'+partnershiplevelID,{},function(resp){
                $("#partnerships tbody").append(resp);
                partnership.editable();
            })
        }
    },
    editable: function () {
        $('#partnerships .editable').editable({
            success: function (response, newValue) {
                $.post('/partnership/partnerships/updatePartnership/'+$(this).attr('data-pk'), {field:$(this).attr('data-field'), value:newValue});
            }
        });
    }
};